import { Component, OnInit, inject } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Observable} from 'rxjs';
import {Client} from '../../../client/client';
import {ClientService} from '../../../client/client.service';
import {map, mergeMap} from 'rxjs/operators';

@Component({
    templateUrl: './client-fiche-beheer.page.html',
    styleUrls: ['./client-fiche-beheer.page.scss'],
    standalone: false
})
export class ClientFicheBeheerPage implements OnInit {
  private clientService = inject(ClientService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);

  client$: Observable<Client>;

  ngOnInit(): void {
    this.client$ = this.route.paramMap
      .pipe(
        map(paramMap => paramMap.get('id')),
        mergeMap(id => this.clientService.getClientById$(id)),
      );
  }

  onCancelClicked(client: Client): void {
    this.router.navigateByUrl(`/clienten/${client.getId()}`);
  }

  onOkClicked(client: Client): void {
    this.clientService.updateClient$(client)
      .subscribe(() => this.router.navigateByUrl(`/clienten/${client.getId()}`));
  }
}
